import * as React from 'react';

// @ts-ignore
import Badge from 'components/Badge';
import Button, { ButtonSize, ButtonColor } from 'components/ButtonDeprecated';

type Props = {
  groupName: string;
  roleRequestsCount: number;
};

export default class PendingRolesButton extends React.Component<Props> {
  render() {
    const { groupName, roleRequestsCount } = this.props;

    const buttonColor = roleRequestsCount > 0 ? ButtonColor.mascot : ButtonColor.paper;
    const badgeColor = roleRequestsCount > 0 ? 'whiteout' : 'percussion';

    return (
      <Button
        level="primary"
        color={buttonColor}
        size={ButtonSize.xsmall}
        to={`/classes/${groupName}/people/pending_roles`}>
        Pending Teachers
        <Badge count={roleRequestsCount} color={badgeColor} size="large" shape="square" />
      </Button>
    );
  }
}
